import { gsap } from 'gsap';
import mixitup from 'mixitup';

export default class Archive {
    constructor() {
        this.init();
    }

    init() {
        const archiveitem = document.querySelectorAll(".archive");
        if (archiveitem.length === 0) return;

        this.setAnime();
        this.setMixitup();
    }

    /**
     * ソート機能
     */
    setMixitup() {
        mixitup('.archive__list__content', {
            animation: { effects: 'fade' },
        });

        const $navitem = [
            ...document.querySelectorAll(".js-pagenav-item span"),
        ];

        $navitem.forEach((el) => {
            el.addEventListener("click", () => {
                el.classList.add("-active");

                $navitem.forEach((els) => {
                    els.classList.remove("-active");
                });
            });
        });
    }

    /**
     * ページ表示アニメ
     */
    setAnime() {
        gsap.set('.archive__list__thumb', { opacity: 0, transform: 'translate(0, 20px)' });

        this.tl = gsap.timeline();
        this.tl
            .call(this.showThumbs.bind(this), null, null, '+=0.2');
    }

    showBtns() {
        gsap.to('.js-pagenav-item', { duration: 0.35, stagger: 0.1, delay:0.85, opacity: 1, transform: 'translate(0, 0)', ease: 'power2.out' });
    }

    showThumbs() {
        const $thumbs = [...document.querySelectorAll(".archive__list__thumb")];
        const ispc = window.matchMedia('only screen and (min-width: 769px)').matches;
        let i = 0;

        $thumbs.forEach((el) => {
            const _delay = ispc ? (i % 3) * 0.1 : 0;

            gsap.to(el, {
                duration: 0.4,
                delay: _delay + 1,
                opacity: 1,
                transform: "translate(0, 0)",
                ease: "power2.out",
            });

            i++;
        });
    }
}
